import {Pipe, PipeTransform} from '@angular/core';
import {IncidentCategory} from "@services";

@Pipe({
    name: 'incidentCategory',
    standalone: true
})
export class IncidentCategoryPipe implements PipeTransform {
    transform(value: IncidentCategory | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case IncidentCategory.IncidentInjury: return "Incident / Injury";
            case IncidentCategory.FoodSafety: return "Food Safety";
            case IncidentCategory.Illness : return "Illness (Personal)";
            case IncidentCategory.NearMiss : return "Near Miss";
            case IncidentCategory.ProductLoss : return "Product Loss";
            case IncidentCategory.PropertyDamage : return "Property Damage";
            default: return value;
        }
    }
}